// Libraries
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

// Api
import contractsApi from '../api/contractsApi';

// Core
import { ResourceTextApplication } from '../core/resources';

// Feature
import { IContractListItem } from '../interfaces/IContract';
import { IFarmDetails } from '../interfaces/IBusinessEntities';
import ViewLoader from '../common/ViewLoader';
import ContractListView from './components/list/ContractListView';

export default function AllContracts(props: { farm: IFarmDetails|null, loading: boolean }) {
    const { farm } = props;
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral', 'AnelmaContract']);
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState<boolean>(true);
    const [contracts, setContracts] = useState<IContractListItem[]>([]);

    useEffect(() => {
        setLoading(true);
        getContracts().then(() => {
            setLoading(false);
        });
    }, []);

    const getContracts = async () => {
        let contracts = await contractsApi.getAllContracts()

        if (!contracts) {
            enqueueSnackbar(t('AnelmaGeneral:1020'), {
                variant: 'error',
            });
        }
        else if (contracts.Items !== null)
            setContracts(contracts.Items);
        else
            setContracts([]);
    }

    return loading || props.loading || !farm
        ? <ViewLoader />
        : <ContractListView
            farm={farm}
            contracts={contracts}
            getContracts={getContracts}
        />;
}
